/** Đánh giá bệnh nhân sau khám. Real /api/v1/feedback. */
import { apiClient } from "./client";

export interface FeedbackItem {
  id: string;
  patientId: string;
  patientName: string;
  encounterId: string | null;
  rating: number;
  comment: string | null;
  submittedVia: string;
  at: string;
}

export interface FeedbackSummary {
  average: number;
  count: number;
  /** counts in 5→1 star order. */
  histogram: number[];
}

export interface FeedbackSubmit {
  patientId: string;
  encounterId?: string | null;
  appointmentId?: string | null;
  rating: number;
  comment?: string | null;
  submittedVia?: string;
}

export const feedbackApi = {
  recent(limit = 100): Promise<FeedbackItem[]> {
    return apiClient.get<FeedbackItem[]>("/v1/feedback", { params: { limit } }).then((r) => r.data);
  },
  summary(): Promise<FeedbackSummary> {
    return apiClient.get<FeedbackSummary>("/v1/feedback/summary").then((r) => r.data);
  },
  submit(body: FeedbackSubmit): Promise<{ id: string }> {
    return apiClient.post<{ id: string }>("/v1/feedback", body).then((r) => r.data);
  },
};

export const feedbackQueryKeys = {
  recent: () => ["feedback", "recent"] as const,
  summary: () => ["feedback", "summary"] as const,
};
